const COMPONENT_TYPE_LABELS = {
  HEADER: "Header",
  BODY: "Body",
  FOOTER: "Footer",
};

function normalizeComponent(component) {
  const normalized = { ...component };

  delete normalized.example;

  normalized.type = COMPONENT_TYPE_LABELS[component.type] || component.type;

  return normalized;
}

export function buildScheduledTemplate(filledTemplate) {
  const components = filledTemplate?.components || [];
  const header = components.find((component) => component.type === "HEADER");
  const body = components.find((component) => component.type === "BODY");
  const footer = components.find((component) => component.type === "FOOTER");

  const componentsWithParameters = components
    .filter((component) => component?.parameters?.length)
    .map((component) => normalizeComponent(component));

  return {
    message: body?.text || " ",

    template: {
      name: filledTemplate.name,
      language: filledTemplate.language,
      header: header?.text || null,
      footer: footer?.text || null,
      components: componentsWithParameters,
    },
  };
}

export default {
  buildScheduledTemplate,
};
